import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BasicLayoutComponent } from 'app/common/layouts/basicLayout.component';
import { SharedModule } from 'app/shared/shared.module';
import { DealerEntryPortalComponent } from './dealer-entry-portal/dealer-entry-portal.component';
import { PortalConfirmationComponent } from './portal-confirmation/portal-confirmation.component';
import { PortalAchConfirmationDialogComponent } from './portal-ach-confirmation-dialog/portal-ach-confirmation-dialog.component';
import { PortalAchComponent } from './portal-ach/portal-ach.component';
import { AchEmailDialogComponent } from './ach-email-dialog/ach-email-dialog.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        RouterModule.forChild([
            {
                path: 'portal',
                component: BasicLayoutComponent,
                children: [
                    { path: '', redirectTo: 'login', pathMatch: 'full' },
                    { path: 'dealer-entry/:code', component: DealerEntryPortalComponent, data: { title: 'Dealer Entry' } },
                    { path: 'dealer-confirmation/:id', component: PortalConfirmationComponent, data: { title: 'Confirmation', hideNav: true } },
                    { path: 'dealer-ach/:id', component: PortalAchComponent, data: { title: 'ACH Portal', hideNav: true } },
                ],
            },
        ]),
    ],
    declarations: [PortalConfirmationComponent, DealerEntryPortalComponent, PortalAchComponent, PortalAchConfirmationDialogComponent, AchEmailDialogComponent],
    exports: [PortalConfirmationComponent],
})
export class PortalModule {}
